<template>
  <b-container class="p-0"  style="text-align: center">
    <b-row style="padding-left: 30px">
      <b-col cols="auto" v-if="hasAttachments">
        <b-btn variant="link" @click="openAttachment">
          <font-awesome-icon icon="paperclip"></font-awesome-icon>
        </b-btn>
      </b-col>
      <b-col v-else cols="auto">
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import ImageViewer from "@/components/img/ImageViewer";

export default {
  name: "AttachmentRendererGrid",
  components: {},

  mounted() {
    this.refresh();
  },

  methods: {
    refresh(){
      this.hasAttachments =  this.model && this.model[this.prop] && this.model[this.prop]?.length;
    },
    openAttachment(){
      //TODO
    }
  },
  watch: {
    rowIndex: function(val){
      this.refresh();
    },
    model: function(val){
      this.refresh();
    },
    prop: function(val){
      this.refresh();
    }
  },
  data: () => ({
    hasAttachments: null
  }),
  props: ["rowIndex", "prop", "model", "column"]

};
</script>